import './NotFoundPage.css';
import faceLogo from '../images/face_logo.png';
import Button from '../components/Button/Button';

function NotFoundPage() {
  return (
    <div className="not-found-page">
      <p className="not-found-label">404 — page not found</p>
      <div className="thank-you-card-404">
        <img src={faceLogo} alt="Heather face graphic" className="thank-you-face-404" />
        <span className="thank-you-text-404">THANK<br />YOU.</span>
      </div>
      <p className="not-found-sub">Thanks for visiting, even if you ended up somewhere unexpected.</p>
      <Button onClick={() => window.location = '/'}>Back to Home</Button>
    </div>
  );
}

export default NotFoundPage;
